import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Align } from '@progress/kendo-angular-popup';
import { lastValueFrom, merge, Subject, takeUntil } from 'rxjs';
import { CurrentIdentityProvider } from '@pl/authorisation-client';
import { WindowRef } from '@progress/kendo-angular-dialog';
import { EntityWindowsService } from '@pl/pl-lib/dialogs';
import { UserService } from '../../../core/services/user';
import { ImpersonationUserSelectComponent } from './impersonation-user-select/impersonation-user-select.component';
import { User } from '../../../core/models/user';

@Component({
  selector: 'app-profile-button',
  templateUrl: './profile-button.component.html',
  styleUrls: ['./profile-button.component.scss']
})
export class ProfileButtonComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();
  public show = false;
  public popupAlign: Align = { horizontal: 'right', vertical: 'top' };
  public anchorAlign: Align = { horizontal: 'right', vertical: 'bottom' };
  isInImpersonationSession: boolean;
  canImpersonate: boolean | undefined;

  @Input()
  public user: User | null;

  constructor(
    private currentIdentityProvider: CurrentIdentityProvider,
    private oAuthService: OAuthService,
    private userService: UserService,
    protected entityWindowService: EntityWindowsService
  ) {}

  ngOnDestroy() {
    this.destroyed$.next();
  }

  error(e: any): void {
    console.log(e);
  }

  onLogout(): void {
    this.oAuthService.logOut();
  }

  async ngOnInit(): Promise<void> {
    this.user =
      this.user || (await lastValueFrom(this.userService.getCurrentUser()));
    this.currentIdentityProvider.isImpersonating$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((e) => (this.isInImpersonationSession = e));
    this.canImpersonate =
      (await this.currentIdentityProvider.canImpersonate(undefined)) === true;
  }

  async onImpersonate() {
    const d = this.entityWindowService.openComponentModal(
      ImpersonationUserSelectComponent,
      {
        width: 500,
        height: 310,
        title: 'Impersonate user...'
      }
    ) as WindowRef;

    const c = d.content.instance as ImpersonationUserSelectComponent;
    c.onCompleted.subscribe(async () => {
      d.close();
    });
  }

  async onEndImpersonation() {
    await this.currentIdentityProvider.endImpersonationSession();
  }
}
